{
  "title": "Plant Growth",
  "source": "Player's Handbook",
  "levelAndSchool": "3rd-level transmutation",
  "level": 3,
  "castingTime": "1 action or 8 hours",
  "range": "150 feet",
  "components": "V, S",
  "duration": "Instantaneous",
  "description": [
    "This spell channels vitality into plants within a specific area. There are two possible uses for the spell, granting either immediate or long-term benefits.",
    "If you cast this spell using 1 action, choose a point within range. All normal plants in a 100-foot radius centered on that point become thick and overgrown. A creature moving through the area must spend 4 feet of movement for every 1 foot it moves.",
    "You can exclude one or more areas of any size within the spell’s area from being affected.",
    "If you cast this spell over 8 hours, you enrich the land. All plants in a half-mile radius centered on a point within range become enriched for 1 year. The plants yield twice the normal amount of food when harvested."
  ],
  "spellLists": ["bard", "druid", "ranger"]
}
